<template>
  <div class="form-section">
    <!-- SECTION - Not Found -->
    <div
      v-if="orders.length === 0 && !loadingRequest"
      class="not-found-section"
    >
      <img
        src="~@/assets/images/rentAdjustment/LockedSchemeArt.png"
        alt="Locked Scheme"
      />
      <div class="not-found-text">
        <span>BELUM TERSEDIA</span>
        <span>Skema pembayaran belum bisa diubah</span>
        <p>
          Fitur untuk mengubah skema pembayaran belum tersedia di versi ini.
          Skema pembayaran akan otomatis disesuaikan dengan tag invoice order
          sebelumnya.
        </p>
      </div>
    </div>
    <!-- !SECTION - Not Found -->
    <div :style="{ display: orders.length === 0 ? 'none' : 'block' }">
      <!-- Start Info Box -->
      <div class="blue-info-box mb-2">
        <div>
          <img src="@/assets/icon/warning-circle-blue.svg" alt="warning" />
        </div>
        <p class="label">
          Skema pembayaran ini dihitung otomatis dari data pada tab
          <strong>Detail</strong>. Pilih order lalu ubah tag pembayarannya
          sebelum lanjut ke tahap Verifikasi.
        </p>
      </div>
      <!-- End Info Box -->
      <!-- Start Action Bar -->
      <div v-if="!disabledInput" class="action-bar mb-2">
        <div class="selection-info" @click="toggleAll">
          <button
            type="button"
            class="tri-checkbox"
            :class="checkboxStateClass"
            :aria-checked="ariaChecked"
            role="checkbox"
            @click.stop="toggleAll"
          >
            <!-- Indeterminate: sebagian dipilih -->
            <svg
              v-if="selectionState === 'partial'"
              width="10"
              height="10"
              viewBox="0 0 10 10"
              fill="none"
            >
              <path
                d="M1.5 5H8.5"
                stroke="#fff"
                stroke-width="1.8"
                stroke-linecap="round"
              />
            </svg>
            <!-- Checked: semua dipilih -->
            <svg
              v-else-if="selectionState === 'all'"
              width="24"
              height="24"
              viewBox="0 0 12 12"
              fill="none"
            >
              <path
                d="M2.5 6.2L4.8 8.5L9.5 3.5"
                stroke="#fff"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>

          <span class="selection-text">
            <strong>{{ selectedCount }} order dipilih</strong> dari
            {{ totalCount }}
          </span>
        </div>

        <change-payment-tag-modal
          :selectedCount="selectedCount"
          :totalCount="totalCount"
          :orders="orders"
        />
      </div>
      <!-- </component-guard> -->
      <!-- End Action Bar -->
      <order-container
        class="mb-3"
        v-for="(order, index) in orders"
        :order="order"
        @input="handleChangeCheckbox($event, index)"
        :value="order.checked"
        :key="index"
      />

      <!-- Start Info -->
      <div
        v-if="!transferUnitStatus || transferUnitStatus === 'draft'"
        class="warning-text"
      >
        <div>
          <img src="@/assets/icon/warning-circle-grey.svg" alt="warning" />
        </div>
        <p class="label">
          Centang beberapa order lalu klik "Ubah tag yang dipilih" untuk ganti
          aturan tagihan sekaligus. Unit dengan tanggal & lama sewa yang sama
          dikelompokkan otomatis.
        </p>
      </div>
      <!-- End Info -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import OrderContainer from "../../CustomComponent/PaymentPreview/OrderContainer.vue";
import ChangePaymentTagModal from "../../CustomComponent/PaymentPreview/ChangePaymentTagModal.vue";
import { ComponentGuard } from "@/components/Permissions";
import mixin from "../../mixin.js";

export default {
  name: "PaymentPreview",
  components: {
    OrderContainer,
    ChangePaymentTagModal,
    ComponentGuard,
  },

  mixins: [mixin],

  data() {
    return {
      orders: [],
    };
  },

  computed: {
    ...mapGetters("rentAdjustment", {
      disabledNotDraft: "getDisabledNotDraft",
      getPaymentSchema: "getPaymentSchema",
      transferUnitStatus: "getStatus",
      loadingRequest: "getLoading",
    }),
    selectedCount() {
      return this.orders.filter((b) => b.checked).length;
    },
    totalCount() {
      return this.orders.length;
    },
    // 'none' | 'partial' | 'all'
    selectionState() {
      if (this.selectedCount <= 0) return "none";
      if (this.selectedCount >= this.totalCount) return "all";
      return "partial";
    },

    checkboxStateClass() {
      return {
        "tri-checkbox--none": this.selectionState === "none",
        "tri-checkbox--partial": this.selectionState === "partial",
        "tri-checkbox--all": this.selectionState === "all",
      };
    },

    ariaChecked() {
      if (this.selectionState === "all") return "true";
      if (this.selectionState === "partial") return "mixed";
      return "false";
    },
  },

  methods: {
    handleChangeCheckbox(isChecked, batchIndex) {
      this.orders[batchIndex].checked = isChecked;
    },
    toggleAll() {
      const newCheckedState = this.selectionState !== "all";
      this.orders.forEach((order) => {
        order.checked = newCheckedState;
      });
    },
  },
  watch: {
    getPaymentSchema: {
      handler(newVal) {
        if (newVal) {
          this.orders = newVal;
        }
      },
      immediate: true,
    },
  },
};
</script>

<style>
button:focus {
  outline: none;
}

.form-section {
  background-color: #ffffff;
  border: 1px solid #d1d9e2;
  border-radius: 0 0 8px 8px;
  padding: 20px;
}

.blue-info-box {
  color: #1d54b0;
  background-color: #eff8ff;
  border: 1px solid #92d4fe;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  display: flex;
  gap: 12px;
}

.blue-info-box p {
  margin: 0;
}

.action-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  background: #f4f5f8;
  border-radius: 10px;
}

/* ---------- Left: checkbox + text ---------- */
.selection-info {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;
}

.tri-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
  flex-shrink: 0;
  border-radius: 4px;
  padding: 0;
}

.tri-checkbox:focus {
  outline: none;
}

.tri-checkbox--none {
  background: #fff;
  border: 1px solid #555358;
}
.tri-checkbox--none:hover {
  border-color: #9aa0ab;
}

.tri-checkbox--partial {
  background: #33363d;
  border: 1px solid #33363d;
}

.tri-checkbox--all {
  background: #2563eb;
  border: 1px solid #2563eb;
}

.selection-text {
  font-size: 13.5px;
  color: #8a8f99;
}
.selection-text strong {
  color: #1f2430;
  font-weight: 600;
}

/* ---------- Right: action button ---------- */
.tag-action-btn {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 8px 16px;
  border-radius: 8px;
  background: #fff;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease,
    background-color 0.15s ease;
}

/* Aktif: ada order dipilih */
.tag-action-btn:not(:disabled) {
  border: 1px solid #2563eb;
  color: #2563eb;
}
.tag-action-btn:not(:disabled):hover {
  background: #eff6ff;
}

/* Nonaktif: belum ada order dipilih */
.tag-action-btn:disabled {
  border: 1px solid #e2e5ea;
  color: #c7cad1;
  cursor: not-allowed;
}

.tag-icon {
  flex-shrink: 0;
}

.warning-text {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  color: #6b7280;
}

.not-found-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 0;
}

.not-found-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  text-align: center;
  color: #5a6482;
  margin-top: 24px;
}

.not-found-text span:first-child {
  font-size: 16px;
  font-weight: 600;
  color: #bb4d00;
  background-color: #fffaea;
  border-radius: 6px;
  padding: 6px 16px;
}

.not-found-text span:nth-child(2) {
  font-size: 24px;
  color: #2e3646;
  font-weight: 700;
}

.not-found-text p {
  font-size: 16px;
  max-width: 600px;
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/RentAdjustment/FormTabs/PaymentPreview/PaymentPreview.vue